module.exports = __webpack_public_path__ + "img/坦克神兵.37ae4272.png";